import { Pipe, PipeTransform } from '@angular/core';
import { BillDocument } from '../../types/documents/BillDocument';

@Pipe({
    name: 'documentType',
    standalone: false,
})
export class DocumentTypeFilter implements PipeTransform {
    transform(documents: BillDocument[], condition: string): BillDocument[] {
        return documents.filter((doc) => doc.documentType.name == condition);
    }
}
